import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Web page segmentation",
  "description": "",
  "published": "2012-05-16T00:00:00.000Z",
  "redirect_from": ["/blog/web-page-segmentation/swizec/4364"],
  "categories": "Algorithm, Information Retrieval, Sorting and Searching, Uncategorized, Web page",
  "hero": "./img/KwdOq.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The Internet talks a lot about article extraction - taking a page and deciding what the real content is. Hell, I've written about the `}<a parentName="p" {...{
        "href": "http://www.zemanta.com/fruitblog/the-uncanny-valley-of-web-scraping/"
      }}>{`Uncanny valley of web scraping`}</a>{` myself.`}</p>
    <p>{`Article extraction is such a wide spread problem that a bunch of API's exist to help you solve it. Everything from a fringe feature in five or ten semantic API's, to startups devoted wholly to extracting articles - like Diffbot.`}</p>
    <p>{`But what if you don't want to extract an article? What if all you want is: `}<em parentName="p">{`this is the header, here is a sidebar, these are ads, here is content, oh and this is a footer, btw those are comments.`}</em></p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "810px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/ab75306eacae74691d93ccacae1cee03/d7542/KwdOq.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.98206278026906%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'193\\'%20viewBox=\\'0%200%20400%20193\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M8%2078v69h100V9H8v69m142-65c-5%203-6%208-3%2012%207%206%2017-3%2011-9-3-3-6-4-8-3m54%200c-2%201-4%206-3%209%202%205%207%206%2011%203%207-5%200-16-8-12m93%200c-6%203-6%2010%200%2013%203%202%205%201%208-1%205-6-1-15-8-12m73%201c-4%205-1%2012%205%2012%207%200%209-8%204-12-3-3-6-3-9%200m-116%201c-4%204-1%2012%205%2012s9-8%205-12c-3-3-8-3-10%200m19%201c-5%207%204%2015%2011%209%203-3%203-6%200-9-3-4-8-4-11%200m60-1c-3%203-3%206%200%209%204%205%2012%203%2012-4%200-6-7-9-12-5M10%2032v3h97v-5l-49-1H10v3m131%2049v53l121%201h121V29H141v52m1-44c0%204%201%206%202%206l1%201-1%201c-1%200-2%202-2%207%200%204%201%206%202%206l1%201-1%201c-1%200-2%202-2%207s1%207%202%206l1%201-1%201c-2%200-2%2014%200%2014v1c-3%200-2%2014%200%2014%202%201%202%201%200%201-1%200-2%201-2%207%200%205%201%207%202%207v1c-1%200-2%201-2%207s0%206%203%206h3V74h7v18c0%2019%200%2019%202%2019s3%201%203%208l1%208%201-48V30h-20v7m22%2041v48h4c3%200%203%200%203-3%200-6%203-5%203%200v4l1-4c1-5%203-5%203-1%200%203%200%204%202%204%203%201%203%200%203-4%200-3%200-3%203-3s3%201%203%204%200%203%202%203c3%200%203%200%203-7l1-7h15v7c0%207%202%2010%202%204v-4h10v4c0%203%201%203%203%203s3%200%203-3c0-4%200-4%204-4s4%200%204-4v-4h4c4%200%205%201%205%204s1%204%202%204l1-44V30h-84v48m85-4a538%20538%200%20003%2037l1-15c1%201%202%203%202%208%201%2011%203%2011%203%200v-8h3c7%200%207%201%207-7l1-8%201-25V30h-21v44m23-22l1%2033v11h7v7l1%209%201-38a285%20285%200%20012-41v-3h-12v22m13-19l1%203%201%2013v13h3c3%200%203%200%203-5v-5h15v67h6V30h-29v3m30%2042v44h45V43h8V30h-53v45m54-35a971%20971%200%20013%2071l1%2011v11h9V30h-13v10M10%2087v51h17V37H10v50m19-44v7h58V37H29v6m59%203c0%208%200%208%202%207h4l2-1v-1c-2%200-4-5-3-7%202-5%209-3%209%202l1%204c2%200%203%203%202%206%200%204-6%204-8%201l-5-1h-4v82h19V88c0-46%200-56-2-49h-1c0-2-1-2-8-2h-8v9M29%2056c0%205%203%206%203%201l1-2v5h41l-1-3%201-5c1-1-1-1-14-1-11%200-16%200-15%201l-3%201c-3%200-3%200-1-1s0-1-5-1h-7v5m0%2044v38h58V62H29v38m237%2013v15h-6c-8-1-9%200-9%202s1%203%205%203l5-1%201-2%201%202%202%201c2%200%202-1%202-17V98l-1%2015M25%20143v2h82v-5H25v3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ab75306eacae74691d93ccacae1cee03/ca0a1/KwdOq.webp 223w", "/static/ab75306eacae74691d93ccacae1cee03/75680/KwdOq.webp 445w", "/static/ab75306eacae74691d93ccacae1cee03/385bc/KwdOq.webp 810w"],
                "sizes": "(max-width: 810px) 100vw, 810px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ab75306eacae74691d93ccacae1cee03/e92b6/KwdOq.png 223w", "/static/ab75306eacae74691d93ccacae1cee03/e66bf/KwdOq.png 445w", "/static/ab75306eacae74691d93ccacae1cee03/d7542/KwdOq.png 810w"],
                "sizes": "(max-width: 810px) 100vw, 810px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ab75306eacae74691d93ccacae1cee03/d7542/KwdOq.png",
                "alt": "Visual vs. Densitometric segmentation (expected)",
                "title": "Visual vs. Densitometric segmentation (expected)",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Visual vs. Densitometric segmentation (expected)`}</figcaption>{`
  `}</figure></p>
    <p>{`Suddenly you are shit out of luck.`}</p>
    <p>{`Sure, it makes sense the API's wouldn't let you do this - it's supposedly their secret magic sauce. Right?`}</p>
    <p>{`Except it isn't.`}</p>
    <p>{`Analyzing the different implementations of article extractors reveals that far from using a methodical approach of marking up different bits of a page, they mostly work as tree `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Pruning_%28decision_trees%29",
        "title": "Pruning (decision trees)"
      }}>{`pruning algorithms`}</a>{` - go through `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Document_Object_Model",
        "title": "Document Object Model"
      }}>{`DOM`}</a>{`, remove anything that's not promising, end up with the juicy article.`}</p>
    <p>{`Nothing you could use to create a web page segmentor ...`}</p>
    <p>{`Turns out, there is but a single very useful paper devoted to web page segmentation - Christian Kohlschütter's `}<em parentName="p"><a parentName="em" {...{
          "href": "https://docs.google.com/viewer?url=http%3A%2F%2Fcoitweb.uncc.edu%2F~jfan%2Fwebimage2.pdf"
        }}>{`A Densitometric Approach to Web Page Segmentation`}</a>{`.`}</em></p>
    <p>{`Yep, the same guy who later wrote `}{`_`}{`Boilerplate Detection using Shallow Text Features, `}{`_`}{`which later turned into `}<a parentName="p" {...{
        "href": "https://code.google.com/p/boilerpipe/"
      }}>{`Boilerpipe`}</a>{`, one of the best (most certainly the quickest) libraries web content extraction.`}</p>
    <p>{`In the paper Kohlschütter explains that only three approaches exist:`}</p>
    <ul>
      <li parentName="ul">{`segmenting visually`}</li>
      <li parentName="ul">{`linguistic approach`}</li>
      <li parentName="ul">{`densitometric approach`}</li>
    </ul>
    <p>{`Visual segmentation is perhaps the easiest to understand - you `}<em parentName="p">{`look`}</em>{` at a website and as a person you instantly know where different sections are. A computer vision algorithm could do something similar. With the caveat you now have to render every page, then run a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Visual_learning",
        "title": "Visual learning"
      }}>{`visual learning`}</a>{` algorithm and do a bunch of things that are computationally very expensive.`}</p>
    <p>{`The linguistic approach is somewhat more reasonable - take a page, look at distributions of words and syllables and what have you (`}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Quantitative_linguistics"
      }}>{`quanititive linguistics`}</a>{` this is called) and decide based on that. Problem here is, this only works well for large blocks of text ... the linguistic content in, say, a header might be somewhat lacking.`}</p>
    <h2 {...{
      "id": "block-fusion-algorithm"
    }}>{`Block fusion algorithm`}</h2>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "795px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/a2b075c99ca655e9e1043b5c47322b90/65c7b/LCupU.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "45.2914798206278%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'181\\'%20viewBox=\\'0%200%20400%20181\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M27%2012v124h90V12H27m120%204c-4%204-1%2011%205%2011%205%200%208-8%204-11-2-3-7-2-9%200m55%201c-2%203-2%203-1%206%202%205%2011%205%2012%200%203-7-7-12-11-6m53-1c-4%204-1%2011%205%2011%203%200%206-3%206-6%200-4-3-7-6-7l-5%202m31%200c-6%206%202%2014%209%209%203-2%203-7%200-9-2-3-7-2-9%200m38%201l-2%204%202%203c4%205%2012%203%2012-3%200-7-8-9-12-4m26%200c-2%203-1%208%203%208l2-2h4c2%202%206%202%206-1%202-4-3-8-6-4-2%202-2%202-3%200-2-2-4-3-6-1M115%2029l-43%201H28v5h13c13%200%2014%200%2014-2%201-2%202-2%2031-2l30-1v-2l-1%201m31%2048l1%2048h108l110-1V29H146v48m2-41c0%205%201%206%202%206v1h-1l-1%206c0%206%200%207%202%207v1c-2%200-2%2011%200%2013v1c-3%200-3%2012%200%2012v1c-3%200-3%2013%200%2013v1c-1%200-2%201-2%206s1%206%202%206v1c-1%201-2%203-2%207%200%205%200%205%202%205h3V96l1-26%202-1h3V31l-6-1h-5v6m12%2031c0%2036%200%2037%202%2037%202%201%202%202%202%207v6h10v-4c0-4%202-4%203%201l1%204v-4c0-5%202-5%202%200%200%202%200%203%202%203s2-1%202-3c0-4%200-4%203-4s3%201%203%204c0%202%200%203%202%203s2-1%202-6v-7h15v7c0%205%200%206%201%203%200-3%201-3%205-4h5v4c0%203%200%203%203%203%202%200%202%200%202-3%200-4%200-4%204-4%203%200%203%200%203-3s0-3%204-3%204%200%204%203c0%202%200%203%203%203l3%201V30h-86v37m95-36l-1%2059h7v-7c0-7%200-7%203-7%202%200%202%200%202%207v7h6v6l1%208%201-34a369%20369%200%20012-37c-1-2-1-3-11-3l-10%201m23%2012c0%2016%200%2016%203%2016s3%200%203-4v-5h13v60h5V30h-25l1%2013m26%2027v40h40V42h7V30h-47v40m52-39v92h8V30h-4l-4%201M56%2034c0%202-1%202-7%202-5%200-6%200-6%202h-1c0-2-1-2-7-2h-7v91h16V83c0-39%200-44%202-44l1-1v-1l1%201h6l2%201c2%200%203-1%203-4s-2-4-3-1m12%200l-1%204c-1%201%201%201%2015%201%2015%200%2016%200%2016-2s1-2%208-2l9-1c1-1-17-2-35-2-13%200-13%200-12%202m31%209c0%207%200%208%202%208%2014%200%2019%202%206%202l-7%201-1%2036v37h17V85l-1-42-4%204c-1%202-5%203-7%201s-1-6%201-7c2-2%202-2%201-3s-1-1%201-1c1-1%200-1-3-1h-5v7m-46%202l-4%201h-4v6c0%205%202%208%203%203l1-2v4h24l24-1c1-3%200-11-1-12l-1%202c0%202-4%205-6%204l-3-3v-3H69l-16%201m236%2042l1%2036%201-36-1-36-1%2036M45%2093v34h53V60l-27-1H45v34m233-3l1%2032c1%201%201-9%201-30l-1-32-1%2030m-124%206l1%2027%201-26-1-26-1%2025M38%20130l39%201%2039-1-39-1-39%201m5%203l37%201%2036-1H43\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a2b075c99ca655e9e1043b5c47322b90/ca0a1/LCupU.webp 223w", "/static/a2b075c99ca655e9e1043b5c47322b90/75680/LCupU.webp 445w", "/static/a2b075c99ca655e9e1043b5c47322b90/399bf/LCupU.webp 795w"],
                "sizes": "(max-width: 795px) 100vw, 795px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a2b075c99ca655e9e1043b5c47322b90/e92b6/LCupU.png 223w", "/static/a2b075c99ca655e9e1043b5c47322b90/e66bf/LCupU.png 445w", "/static/a2b075c99ca655e9e1043b5c47322b90/65c7b/LCupU.png 795w"],
                "sizes": "(max-width: 795px) 100vw, 795px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a2b075c99ca655e9e1043b5c47322b90/65c7b/LCupU.png",
                "alt": "Visual vs. Densitometric (actual)",
                "title": "Visual vs. Densitometric (actual)",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Visual vs. Densitometric (actual)`}</figcaption>{`
  `}</figure></p>
    <p>{`Kohlschütter's densitometric approach has a tendency to work as well as a visual algorithm, while being as fast as a lingustic approach ... bloody marvelous!`}</p>
    <p>{`The idea is basically this:`}</p>
    <ul>
      <li parentName="ul">{`walk through nodes`}</li>
      <li parentName="ul">{`assign a text density to each node -> number-of-tokens / number-of-'lines'`}</li>
      <li parentName="ul">{`merge neighbor nodes with the same densities`}</li>
      <li parentName="ul">{`repeat until desired granularity is reached`}</li>
    </ul>
    <p>{`The simplicity of this algorithm is just brilliant. Even better is the fact they managed to get it down to `}<em parentName="p">{`15ms`}</em>{` per page on average. For comparison's sake - the time it takes Readability to clean up a page is counted in seconds, an average response time from Diffbot (visual approach) is about `}<em parentName="p">{`10 seconds per page.`}</em></p>
    <p>{`Yep, that fast.`}</p>
    <p>{`And for the icing on the cake - most main bits of the Block Fusion Algorithm are already implemented deep inside the bowels of Boilerpipe. You just have to look hard enough.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.zemanta.com/fruitblog/the-uncanny-valley-of-web-scraping/"
        }}>{`The uncanny valley of web scraping`}</a>{` (zemanta.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.marketingtechblog.com/eyequant/"
        }}>{`Eyequant: Heatmapping on the Fly`}</a>{` (marketingtechblog.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.npr.org/blogs/alltechconsidered/2012/05/14/152444019/algorithms-the-ever-growing-all-knowing-way-of-the-future?ft=1&f=1049"
        }}>{`Algorithms: The Ever-Growing, All-Knowing Way Of The Future`}</a>{` (npr.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.daniweb.com/software-development/python/threads/423356/webscraping-with-beautiful-soup-extracting-images"
        }}>{`webscraping with beautiful soup (extracting images)`}</a>{` (daniweb.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.johndcook.com/blog/2012/05/15/machine-learning-in-action/"
        }}>{`Machine Learning in Action`}</a>{` (johndcook.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=80957035-03c6-4cce-93f6-3c07a987921a",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      